<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="tabs"></ng-container>
        <ng-container *ngTemplateOutlet="currency"></ng-container>

        <div [hidden]="selectedBgValuta === 'OTHER'">
            <ng-container *ngTemplateOutlet="exchange"></ng-container>
        </div>

        <div [hidden]="selectedBgValuta === 'BASIC'">
            <ng-container *ngTemplateOutlet="description"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="valuta_basic">
                <ng-container *ngTemplateOutlet="currency"></ng-container>
                <ng-container *ngTemplateOutlet="exchange"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="valuta_other">
                <ng-container *ngTemplateOutlet="description"></ng-container>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-6 p-5">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #tabs>
    <ng-container *ngIf="!!edit">
        <tt-tabs [(ttSelectedId)]="selectedBgValuta">
            <tt-tab ttId="BASIC" ttLabel="valuta_basic"></tt-tab>
            <tt-tab ttId="OTHER" ttLabel="valuta_other"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #currency>
    <ng-container *ngIf="!!edit">
        <tt-input *ngIf="edit.is_new === '0'" ttLabel="valuta_id" [(ttModel)]="edit.valuta_id" ttReadonly></tt-input>
        <tt-input *ngIf="edit.is_new === '1'" ttLabel="valuta_id" [(ttModel)]="edit.valuta_id"></tt-input>
    </ng-container>
</ng-template>

<ng-template #exchange>
    <ng-container *ngIf="!!edit">
        <tt-input-number *ngIf="valutaId !== '+'" ttLabel="valuta_exchangerate" [(ttModel)]="edit.valuta_exchangerate" ttTextAlign="right" ttFormatNumber ttDecimals="6" ttReadonly></tt-input-number>
        <tt-input-number *ngIf="valutaId === '+'" ttLabel="valuta_exchangerate" [(ttModel)]="edit.valuta_exchangerate" (ttModelChange)="onChanged($event, 'valuta_exchangerate')" ttTextAlign="right" ttFormatNumber ttDecimals="6"></tt-input-number>
        <tt-input-number ttLabel="valuta_pr" [(ttModel)]="edit.valuta_pr" (ttModelChange)="onChanged($event, 'valuta_pr')" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-input-number ttLabel="valuta_exchangefactor" [(ttModel)]="edit.valuta_exchangefactor" ttTextAlign="right" ttFormatNumber ttDecimals="6" ttReadonly></tt-input-number>
    </ng-container>
</ng-template>

<ng-template #description>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="valuta_name" [(ttModel)]="edit.valuta_name"></tt-input>
        <tt-select ttLabel="round_off" [(ttModel)]="edit.round_off" [ttData]="selectListRoundOff" ttDataId="roundoff_id" ttDataName="roundoff_name"></tt-select>
        <tt-select ttLabel="country" [(ttModel)]="edit.country_id" [ttData]="selectListCountries" ttDataId="country_id" ttDataName="country_name"></tt-select>
        <tt-input ttLabel="fci" [(ttModel)]="edit.fci"></tt-input>
        <tt-input ttLabel="valuta_code" [(ttModel)]="edit.valuta_code"></tt-input>
        <tt-input ttLabel="valuta_code_factoring" [(ttModel)]="edit.valuta_code_factoring"></tt-input>
        <tt-checkbox ttLabel="isbasecurrency" [(ttModel)]="edit.isbasecurrency"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!edit">
        <tt-button-save ttText="valuta_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>



<!--<tt-page class="col-xs-12 sp-0" ng-if="vm.model.tabletSize.matches === false">
    <tt-card class="col-xs-12 sp-0">
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgValuta.buttons" tt-model="vm.model.bgValuta.selected" tt-change="vm.selectBgValuta($value, $modelId)"></tt-buttons-radio>
        <tt-input ng-if="vm.model.edit.is_new === '0'" class="col-xs-12 sp-0" tt-label="valuta_id" tt-model="vm.model.edit.valuta_id" tt-change="vm.model.edit.valuta_id = $value" tt-readonly="true"></tt-input>
        <tt-input ng-if="vm.model.edit.is_new === '1'" class="col-xs-12 sp-0" tt-label="valuta_id" tt-model="vm.model.edit.valuta_id" tt-change="vm.model.edit.valuta_id = $value" tt-placeholder=""></tt-input>

        <div ng-show="vm.model.bgValuta.selected === 'BASIC'">
            <tt-input-number ng-if="vm.model.valutaId !== '+'" class="col-xs-12 sp-0" tt-label="valuta_exchangerate" tt-model="vm.model.edit.valuta_exchangerate" tt-change="vm.onChanged($value, 'valuta_exchangerate')" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 6 }" tt-readonly="true"></tt-input-number>
            <tt-input-number ng-if="vm.model.valutaId === '+'" class="col-xs-12 sp-0" tt-label="valuta_exchangerate" tt-model="vm.model.edit.valuta_exchangerate" tt-change="vm.onChanged($value, 'valuta_exchangerate')" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 6 }"></tt-input-number>
            <tt-input-number class="col-xs-12 sp-0" tt-label="valuta_pr" tt-model="vm.model.edit.valuta_pr" tt-change="vm.onChanged($value, 'valuta_pr')" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }"></tt-input-number>
            <tt-input-number class="col-xs-12 sp-0" tt-label="valuta_exchangefactor" tt-model="vm.model.edit.valuta_exchangefactor" tt-change="vm.model.edit.valuta_exchangefactor = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 6 }" tt-readonly="true"></tt-input-number>
        </div>

        <div ng-show="vm.model.bgValuta.selected === 'OTHER'">
            <tt-input class="col-xs-12 sp-0" tt-label="valuta_name" tt-model="vm.model.edit.valuta_name" tt-change="vm.model.edit.valuta_name = $value" tt-placeholder=""></tt-input>
            <tt-select class="col-xs-12 sp-0" tt-label="round_off" tt-model="vm.model.edit.round_off" tt-change="vm.model.edit.round_off = $value" tt-data="vm.model.selectListRoundOff" tt-data-id="roundoff_id" tt-data-name="roundoff_name"></tt-select>
            <tt-select class="col-xs-12 sp-0" tt-label="country" tt-model="vm.model.edit.country_id" tt-change="vm.model.edit.country_id = $value" tt-data="vm.model.selectListCountries" tt-data-id="country_id" tt-data-name="country_name"></tt-select>
            <tt-input class="col-xs-12 sp-0" tt-label="fci" tt-model="vm.model.edit.fci" tt-change="vm.model.edit.fci = $value" tt-placeholder=""></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="valuta_code" tt-model="vm.model.edit.valuta_code" tt-change="vm.model.edit.valuta_code = $value" tt-placeholder=""></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="valuta_code_factoring" tt-model="vm.model.edit.valuta_code_factoring" tt-change="vm.model.edit.valuta_code_factoring = $value" tt-placeholder=""></tt-input>
            <tt-checkbox class="col-xs-12 sp-0" tt-label="isbasecurrency" tt-model="vm.model.edit.isbasecurrency" tt-change="vm.model.edit.isbasecurrency = $value"></tt-checkbox>
        </div>

        <tt-button-save class="col-xs-12 sp-0" tt-text="valuta_save" tt-locked="" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
